/**
 * UI component for App.
 * This file owns the screen or feature-level presentation flow for its route or
 * embedded module context.
 */
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UiLoaderOutletComponent, UiToastOutletComponent } from '@shared/ui';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, UiToastOutletComponent, UiLoaderOutletComponent],
  templateUrl: './app.component.html'
})
export class AppComponent {}
